import { useEffect, useRef, useState } from "react";
import { useNotify, useTranslate } from "react-admin";
import { copyText } from "utils/clipboard";

const COPIED_RESET_MS = 1500;

export const useCopyFeedback = () => {
	const notify = useNotify();
	const translate = useTranslate();
	const timerRef = useRef(null);
	const [copied, setCopied] = useState(false);

	useEffect(() => () => clearTimeout(timerRef.current), []);

	const copy = (text) => {
		if (!text) return;
		copyText(text, notify, translate);
		setCopied(true);
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(() => setCopied(false), COPIED_RESET_MS);
	};

	return { copied, copy };
};
